import { SUPPORTED_LOCALE_CODES } from './constants';

export interface StoreState {
  readonly intl?: { readonly locale?: string };
}

export enum AbbreviationLocalisationKey {
  THOUSANDS = 'abbreviation.thousands',
  MILLIONS = 'abbreviation.millions',
  BILLIONS = 'abbreviation.billions',
  TRILLIONS = 'abbreviation.trillions'
}

export type SupportedLocaleCode = typeof SUPPORTED_LOCALE_CODES[number];
